"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KYB_TRADE_READY_REASONS = void 0;
// Stable, machine-readable set. Downstream consumers map these to user-facing
// copy; renaming a code is a breaking change.
exports.KYB_TRADE_READY_REASONS = [
    'ok',
    'kyb_not_approved',
    'recycling_licence_expired',
    'kyb_effective_date_missing',
    'counterparty_not_found',
    'counterparty_soft_deleted',
];
//# sourceMappingURL=gate.js.map